import keycloakAxios from '@/services/axios';
import {updateEventInRedux} from '@/redux-store/slices/events';
import {store} from '@/redux-store/store';
import {emitEventChangeEvent} from './change-observable';
import {env} from '@/config';

const {VERSION} = env;

export const joinEvent = async (eventId: string) => {
  const response = await keycloakAxios.get(`event/${eventId}/join`, {
    headers: {
      'X-App-Version': VERSION,
      'X-App-Platform': 'web'
    }
  });

  if (response.status >= 300) {
    throw new Error(
      `Error joining the event: Invalid status code: ${response.status}`
    );
  }

  const updatedResponseData = {
    ...response.data,
    price: response.data.price > 0 ? response.data.price / 100 : 0
  };

  emitEventChangeEvent({
    type: 'change',
    data: updatedResponseData
  });

  store.dispatch(updateEventInRedux({event: updatedResponseData}));

  return updatedResponseData;
};
